import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle,
} from '@material-ui/core';
import { t } from 'src/lib/language';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { DIALOGS } from 'src/models/DialogModel';
import { closeDialog } from 'src/redux/actions/dialogActions';
import { deleteTaxAction } from 'src/redux/actions/taxActions';
import { FORM, FORM_STATUS } from 'src/constants/Form';

const DeleteTaxDialog = () => {
  const dispatch = useAppDispatch();

  const { opened, payload } =
    useSelector((state: Store) => {
      if (state.dialog[DIALOGS.deleteTax]) {
        return state.dialog[DIALOGS.deleteTax];
      }
      return { opened: false, payload: null };
    });

  const lang = useSelector((state: Store) => state.language.language ?? 'en');

  const processing = useSelector(
    (state: Store) => state.formStatus[FORM.delete_tax] === FORM_STATUS.processing,
  );

  const handleCancel = () => {
    dispatch(closeDialog({ dialog: DIALOGS.deleteTax }));
  };

  const handleOk = () => {
    dispatch(closeDialog({ dialog: DIALOGS.deleteTax }));
    dispatch(deleteTaxAction(payload));
  };

  return (
    <Dialog
      maxWidth="xs"
      aria-labelledby="deleting-tax"
      open={opened}>
      <DialogTitle id="deleting-tax">{t(lang, 'menus.deleting_tax')}</DialogTitle>
      <DialogContent dividers>
        {t(lang, 'menus.deleting_tax_confirmation')}
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel} color="primary" disabled={processing}>
          {t(lang, 'misc.no')}
        </Button>
        <Button onClick={handleOk} color="primary" disabled={processing}>
          {t(lang, 'misc.yes')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteTaxDialog;
